import { usePermissionsOptimized } from "ra-core"
import { useMemo } from "react"
import { SECUREFILE_ONLY } from "~/constants"

export const useIsSecureFileOnly = () => {
  const permissions = usePermissionsOptimized().permissions
  const isSecureFileOnly = useMemo(() => {
    return Boolean(permissions) && (permissions as ReadonlyArray<string>).indexOf(SECUREFILE_ONLY) > -1
  }, [permissions])
  return isSecureFileOnly
}